/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, computed, observable } from 'mobx';
import { QnaMakerQnaSwagger } from 'src/qnaMaker/core/services/qnas/QnaMakerAssetsSwaggers';

export class QnaMakerQnaPairsBeingEditedStore {
    @observable public qnaPairsBeingEditedMap: Map<number, Partial<QnaMakerQnaSwagger>>;

    constructor() {
        this.qnaPairsBeingEditedMap = new Map();
    }

    @computed
    public get qnaPairsBeingEditedIds() {
        return [...this.qnaPairsBeingEditedMap.keys()];
    }

    @computed
    public get hasPairsInEditMode() {
        return Boolean(this.qnaPairsBeingEditedMap.size);
    }

    @action
    public hasPair(pairId: number) {
        return this.qnaPairsBeingEditedMap.has(pairId);
    }

    @action
    public addPair(pair: Partial<QnaMakerQnaSwagger>) {
        if (this.qnaPairsBeingEditedMap.has(pair.id)) {
            return;
        }

        this.qnaPairsBeingEditedMap.set(pair.id, pair);
    }

    @action
    public updatePair(pair: Partial<QnaMakerQnaSwagger>) {
        if (!pair.id) {
            return;
        }

        this.qnaPairsBeingEditedMap.set(pair.id, pair);
    }

    @action
    public deletePair(pairId: number) {
        this.qnaPairsBeingEditedMap.delete(pairId);
    }

    @action
    public clearAllPairs() {
        this.qnaPairsBeingEditedMap.clear();
    }

    @action
    public getPair(pairId: number) {
        if (this.qnaPairsBeingEditedMap.has(pairId)) {
            return this.qnaPairsBeingEditedMap.get(pairId);
        }
    }
}
